import script from "./MGExpansionPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./MGExpansionPanel.vue?vue&type=script&setup=true&lang=ts"

import "./MGExpansionPanel.vue?vue&type=style&index=0&id=c7e07a64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7e07a64"]])

export default __exports__